module.exports = __webpack_public_path__ + "static/Onsite-Clinics-Employee-Healthcare-min-1f39a455ae97327142bcc402d2813357.png";